export const TypingAnimation = () => {
  return <div class="inline-block w-2 h-4 bg-blue-500 animate-pulse ml-1" />;
};
